<div class="showtimes-modal">
    <finder-date-picker-wrapper
        [labels]="labels"
        [(date)]="scheduleService.date"
        [maxDays]="data?.maxDays"
        (dateChanged)="onDateChanged($event)"
        (datePickerClose)="onCalendarClose($event)">
            <label class="label">Date</label>
            <finder-input class="date-input" type="text" [value]="scheduleService.fullFormatDate" readonly="readonly"></finder-input>
    </finder-date-picker-wrapper>
    <finder-loading-spinner *ngIf="scheduleService.isLoading"></finder-loading-spinner>
    <div [hidden]="scheduleService.isLoading" class="schedules" *ngIf="showSchedules; else empty">
        <div class="schedules-content"
            [ngClass]="{'operating': scheduleType === types.operating}"
            *ngFor="let scheduleType of scheduleTypes">
            <div class="schedule-label" *ngIf="scheduleLabels[scheduleType]">
                {{ scheduleLabels[scheduleType] }} <span *ngIf="scheduleService.displayScheduleList(scheduleType)">&#8211;&nbsp;</span>
            </div>
            <finder-schedule-list
                *ngIf="scheduleService.displayScheduleList(scheduleType)"
                class="schedule-list"
                [separator]="scheduleLabels.scheduleToLabel"
                [separatorLabel]="scheduleLabels.scheduleAndLabel"
                [times]="schedules[scheduleType]">
            </finder-schedule-list>
        </div>
        <div *ngFor="let scheduleGroupType of scheduleGroupTypes">
            <div class="schedule-info" *ngFor="let group of scheduleGroupKeys[scheduleGroupType]">
                <div class="schedule-label">{{ group }}</div>
                <div>
                    <finder-schedule-list
                        class="schedule-times"
                        [separator]="scheduleLabels.scheduleToLabel"
                        [separatorLabel]="scheduleLabels.scheduleAndLabel"
                        [times]="schedules[scheduleGroupType][group]">
                    </finder-schedule-list>
                </div>
            </div>
        </div>
    </div>
    <ng-template #empty>
        <div class="empty-schedule" [hidden]="scheduleService.isLoading">
            {{scheduleService.schedule?.labels?.emptySchedule}}
        </div>
    </ng-template>
</div>
